import { useQuery } from 'react-query'
import { getWOGContacts } from '../api'

export const useGetWOGContacts = () => {
  return useQuery(
    ['wog-contacts'],
    () => getWOGContacts(),
    { keepPreviousData: true },
  )
}
